import React from "react";
import { format } from "date-fns";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { DatePicker } from "@/components/ui/date-picker";
import { UseFormReturn } from "react-hook-form";
import { StaffFormValues } from "../StaffForm";

interface StartDateFieldProps {
  form: UseFormReturn<StaffFormValues>;
  disabled?: boolean;
  description?: string;
}

const StartDateField: React.FC<StartDateFieldProps> = ({ 
  form, 
  disabled = false,
  description 
}) => {
  return (
    <FormField
      control={form.control}
      name="start_date"
      render={({ field }) => (
        <FormItem className="flex flex-col">
          <FormLabel>Start Date</FormLabel>
          <FormControl>
            <DatePicker
              value={field.value ? new Date(field.value as string) : undefined}
              onChange={(date) => field.onChange(date ? format(date, "yyyy-MM-dd") : null)}
              disabled={disabled}
              disabledDates={(date) => date > new Date()}
              placeholder="Pick a date"
              className="w-full"
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default StartDateField; 